import React, { useState } from 'react'
import DashModalV2 from '../../components/DashModalV2'
import { Btn, Field, INPUT_STYLE, todayIso, useSaving } from './FieldOpsKit'

/**
 * Field Ops modals (demo). ReasonModal reuses DashModalV2 (the project's standard modal) and simulates a short
 * "saving" state. The salesperson's check-in / order / store picker moved to the field app (field/*, 2026-11-04).
 */

const TEXTAREA = { ...INPUT_STYLE, width: '100%', minHeight: 70, resize: 'vertical' }

/** Ask for a reason (and optionally a date) before a sensitive change: return to draft, cancel, reschedule... */
export const ReasonModal = ({ show, title, subtitle, reasons, requireReason, withDate, dateLabel, minDate, defaultDate, confirmLabel, tone, onConfirm, onClose }) => {
    const [reason, setReason] = useState('')
    const [note, setNote] = useState('')
    const [date, setDate] = useState(defaultDate || todayIso())
    const [tried, setTried] = useState(false)
    const [busy, run] = useSaving()
    const needReason = requireReason !== false
    const reasonMissing = needReason && reasons && !reason
    const dateBad = withDate && (!date || (minDate && date < minDate))
    const submit = () => {
        setTried(true)
        if (reasonMissing || dateBad) return
        run(() => { onConfirm({ reason: reason, note: note, date: date }) })
    }
    return (
        <DashModalV2 show={show} onClose={onClose} title={title} subtitle={subtitle} size="md"
            footer={<React.Fragment>
                <Btn kind="secondary" onClick={onClose}>Cancel</Btn>
                <Btn kind={tone === 'danger' ? 'danger' : 'primary'} busy={busy} onClick={submit}>{confirmLabel || 'Confirm'}</Btn>
            </React.Fragment>}>
            {withDate ? (
                <Field label={dateLabel || 'New date'} error={tried && dateBad ? 'Pick a valid date' + (minDate ? ' (' + minDate + ' or later)' : '') : ''}>
                    <input type="date" value={date} min={minDate} onChange={(e) => setDate(e.target.value)} style={INPUT_STYLE} />
                </Field>
            ) : null}
            {reasons ? (
                <Field label="Reason" error={tried && reasonMissing ? 'Select a reason' : ''}>
                    <select value={reason} onChange={(e) => setReason(e.target.value)} style={{ ...INPUT_STYLE, width: '100%' }}>
                        <option value="">Select a reason…</option>
                        {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                </Field>
            ) : null}
            <Field label="Note (optional)"><textarea value={note} onChange={(e) => setNote(e.target.value)} style={TEXTAREA} placeholder="Add details for the history" /></Field>
        </DashModalV2>
    )
}
